import { registerThemeInjector } from '@dojo/framework/core/mixins/Themed';
import { ThemeInjector } from '@dojo/framework/core/ThemeInjector';
import { registry } from './base';

export const themeContext: ThemeInjector = registerThemeInjector({}, registry);
